import { AcquisitionChannel } from '@nemuru-eng/js-api-client';
import React from 'react';

import { Text } from '../components/shared/components/Text';

export const AcquisitionChannelOptions = Object.values(AcquisitionChannel).map((value) => ({
  value,
  display: <Text tId={value} />,
}));
